import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 从环境变量读取基础路径
const basePath = import.meta.env.VITE_BASE_PATH || import.meta.env.BASE_URL || '/'

// 调试打印
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/watchlist',
    meta: { requiresAuth: true }
  },
  {
    path: '/watchlist',
    name: 'Watchlist',
    component: () => import('@/views/Watchlist.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/intraday-score-workbench',
    name: 'IntradayScoreWorkbench',
    component: () => import('@/views/IntradayScoreWorkbench.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/positions',
    name: 'Positions',
    component: () => import('@/views/PositionsManagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/strategy-groups',
    name: 'StrategyGroups',
    component: () => import('@/views/StrategyGroups.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/strategy-editor',
    name: 'StrategyEditor',
    component: () => import('@/views/StrategyEditor.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/trade-review',
    name: 'TradeReview',
    component: () => import('@/views/TradeReview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/training',
    name: 'TrainingCenter',
    component: () => import('@/views/TrainingCenter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('@/views/Statistics.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/chan-theory',
    name: 'ChanTheory',
    component: () => import('@/views/ChanTheory.vue'),
    meta: { requiresAuth: true }
  },
    // 移动端专用路由
  {
    path: '/mobile',
    component: () => import('@/components/mobile/MobileLayout.vue'),
    children: [
      {
        path: 'watchlist',
        name: 'MobileWatchlist',
        component: () => import('@/views/mobile/MobileWatchlist.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'positions',
        name: 'MobilePositions',
        component: () => import('@/views/mobile/MobilePositions.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'statistics',
        name: 'MobileStatistics',
        component: () => import('@/views/mobile/MobileStatistics.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'sector-leaders',
        name: 'MobileSectorLeaders',
        component: () => import('@/views/mobile/MobileSectorLeaders.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'key-stocks',
        name: 'MobileKeyStocks',
        component: () => import('@/views/mobile/MobileKeyStocks.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'advanced-backtest',
        name: 'MobileAdvancedBacktest',
        component: () => import('@/views/mobile/MobileAdvancedBacktest.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'intraday-score-workbench',
        name: 'MobileIntradayScoreWorkbench',
        component: () => import('@/views/IntradayScoreWorkbench.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'dragon-tiger',
        name: 'MobileDragonTiger',
        component: () => import('@/views/mobile/MobileDragonTiger.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'hot-news',
        name: 'MobileHotNews',
        component: () => import('@/views/HotNewsMobile.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'ai-balance',
        name: 'MobileAIBalance',
        component: () => import('@/views/mobile/MobileAIBalance.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'fund-portfolio',
        name: 'MobileFundPortfolio',
        component: () => import('@/views/mobile/MobileFundPortfolio.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'institution-strategy',
        name: 'MobileInstitutionStrategy',
        component: () => import('@/views/mobile/MobileInstitutionStrategy.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'intraday-selections',
        name: 'MobileIntradaySelections',
        component: () => import('@/views/mobile/MobileIntradaySelections.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'trade-review',
        name: 'MobileTradeReview',
        component: () => import('@/views/mobile/MobileTradeReview.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'training',
        name: 'MobileTrainingCenter',
        component: () => import('@/views/mobile/MobileTrainingCenter.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'plans',
        name: 'MobileTradePlans',
        component: () => import('@/views/mobile/MobileTradePlans.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'research',
        name: 'MobileResearchHome',
        component: () => import('@/research/views/mobile/MobileResearchHome.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'research/stocks/:code',
        name: 'MobileResearchStock',
        component: () => import('@/research/views/mobile/MobileResearchStock.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'research/industries/:industry_code',
        name: 'MobileResearchIndustry',
        component: () => import('@/research/views/mobile/MobileResearchIndustry.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'research/weekly',
        name: 'MobileResearchWeekly',
        component: () => import('@/research/views/mobile/MobileResearchWeekly.vue'),
        meta: { requiresAuth: true }
      }

    ]
  },
  {
    // 移动端独立股票详情页（1:1 同花顺高保真复刻，全屏无底栏）
    path: '/mobile/stock-detail/:code',
    name: 'MobileStockDetail',
    component: () => import('@/views/mobile/MobileStockDetailPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/plans',
    name: 'TradePlans',
    component: () => import('@/views/TradePlans.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/sector-leaders',
    name: 'SectorLeaderSearch',
    component: () => import('@/views/SectorLeaderSearch.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/dragon-tiger',
    name: 'DragonTiger',
    component: () => import('@/views/DragonTiger.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/key-stocks',
    name: 'KeyStocks',
    component: () => import('@/views/KeyStocks.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/institution-strategy',
    name: 'InstitutionStrategy',
    component: () => import('@/views/InstitutionStrategy.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/intraday-selections',
    name: 'IntradaySelections',
    component: () => import('@/views/IntradaySelections.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/Admin.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/pattern-mining',
    name: 'PatternMining',
    component: () => import('@/pattern-mining/views/PatternMining.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/research',
    name: 'ResearchHome',
    component: () => import('@/research/views/desktop/ResearchHome.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/research/stocks/:code',
    name: 'ResearchStock',
    component: () => import('@/research/views/desktop/ResearchStock.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/research/industries/:industry_code',
    name: 'ResearchIndustry',
    component: () => import('@/research/views/desktop/ResearchIndustry.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/research/weekly',
    name: 'ResearchWeekly',
    component: () => import('@/research/views/desktop/ResearchWeekly.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/fund-portfolio',
    name: 'FundPortfolio',
    component: () => import('@/views/FundPortfolio.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/hot-news',
    name: 'HotNews',
    component: () => import('@/views/HotNewsDesktop.vue'),
    meta: { requiresAuth: true }
  },
  // Advanced Backtest Routes
  {
    path: '/advanced-backtest',
    name: 'AdvancedBacktest',
    component: () => import('@/views/AdvancedBacktest.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdvancedBacktestDefault',
        redirect: '/advanced-backtest/config'
      },
      {
        path: 'config',
        name: 'AdvancedBacktestConfig',
        component: () => import('@/components/AdvancedBacktestConfigForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'history',
        name: 'AdvancedBacktestHistory',
        component: () => import('@/components/BacktestTaskManager.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'result/:id',
        name: 'AdvancedBacktestResult',
        component: () => import('@/components/AdvancedBacktestResultDashboard.vue'),
        meta: { requiresAuth: true },
        props: true
      },
      {
        path: 'optimize',
        name: 'AdvancedBacktestOptimize',
        component: () => import('@/components/ParameterOptimizationResult.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'pattern',
        name: 'AdvancedBacktestPattern',
        component: () => import('@/components/desktop/DesktopKlinePatternMatcher.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(basePath),
  routes
})

// 路由守卫 - 认证检查
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()

  // 移动端路由重定向
  const isMobile = window.innerWidth < 768
  const mobileRouteMap = {
    '/watchlist': '/mobile/watchlist',
    '/positions': '/mobile/positions',
    '/plans': '/mobile/plans',
    '/statistics': '/mobile/statistics',
    '/sector-leaders': '/mobile/sector-leaders',
    '/sector-leaders': '/mobile/sector-leaders',
    '/key-stocks': '/mobile/key-stocks',
    '/advanced-backtest': '/mobile/advanced-backtest',
    '/dragon-tiger': '/mobile/dragon-tiger',
    '/hot-news': '/mobile/hot-news',
    '/fund-portfolio': '/mobile/fund-portfolio',
    '/trade-review': '/mobile/trade-review',
    '/training': '/mobile/training',
    '/intraday-selections': '/mobile/intraday-selections',
    '/research': '/mobile/research'
  }

  // 如果是移动端访问桌面端路由，重定向到移动端路由
  if (isMobile && mobileRouteMap[to.path]) {
    next(mobileRouteMap[to.path])
    return
  }

  // 产业研究子路由：/research/* → /mobile/research/*
  if (isMobile && to.path.startsWith('/research/')) {
    next(`/mobile${to.path}`)
    return
  }

  // 如果是桌面端访问移动端路由，重定向到桌面端路由（排除无对应桌面端页面的专用移动端详情页）
  if (!isMobile && to.path.startsWith('/mobile/') && !to.path.startsWith('/mobile/stock-detail')) {
    const desktopPath = to.path.replace('/mobile', '')
    next(desktopPath)
    return
  }

  // 调试打印路由信息
  // 检查是否需要认证
  if (to.meta.requiresAuth) {
    if (!authStore.isAuthenticated) {
      // 未登录，重定向到登录页
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
      return
    }

    // 如果有token但没有用户信息，尝试获取用户信息
    if (!authStore.user) {
      try {
        await authStore.fetchUser()
      } catch (error) {
        // 获取用户信息失败，可能token无效，重定向到登录页
        next({
          name: 'Login',
          query: { redirect: to.fullPath }
        })
        return
      }
    }

    // 检查是否需要管理员权限
    if (to.meta.requiresAdmin && !authStore.isAdmin) {
      // 非管理员，重定向到首页
      next({ name: 'Home' })
      return
    }
  }

  // 已登录用户访问登录页，重定向到首页
  if (to.name === 'Login' && authStore.isAuthenticated) {
    next({ name: 'Home' })
    return
  }
  next()
})

export default router
